import { Box, Paper } from "@mui/material";
import { useState, useEffect } from "react";

export default function Admin() {
  const cached = localStorage.getItem("adminSettings");
  const intialSettings = cached
    ? JSON.parse(cached)
    : {
        domainFinder: false,
      };

  const [settings, setSettings] = useState(intialSettings);

  useEffect(() => {
    localStorage.setItem("adminSettings", JSON.stringify(settings));
  }, [settings]);

  return (
    <Paper elevation={2} sx={{ mt: 3, p: 3 }}>
      <Box sx={{ p: 3 }}>
        <label>Show domain finder?</label>
        <input
          type="checkbox"
          checked={settings.domainFinder}
          onChange={() =>
            setSettings({ ...settings, domainFinder: !settings.domainFinder })
          }
        />
      </Box>
    </Paper>
  );
}
